import React from 'react';
import Pages from './Pages'
import '../Projects.css'

export default function DisplayProjects() {
  return (
    <>
      <section className="articles about__me section" name='projects'>
        <div className="sec-title centered" data-aos="zoom-in">
          <h2>My Projects</h2>
        </div>
        <div className="article__content container container--pall">
          <div className="article__grid">
            <Pages />
          </div>
        </div>
      </section>
    </>
  );
}
